import { useContext } from 'react';
import { SeoTextLoadingContext } from './SeoTextLoadingProvider/SeoTextLoadingProvider';

const SeoPageHeading = ({ children, ...props }) => {
  const { isLoaded } = useContext(SeoTextLoadingContext);
  const Component = isLoaded ? 'span' : 'h1';

  return <Component {...props}>{children}</Component>;
};

export default SeoPageHeading;
